export enum OwnerType {
  Bag = "bag",
  VehicleTrunk = "vehicle_trunk",
  Environment = "environment",
  Character = "character",
  Wallet = "wallet",
  Confiscation = "confiscation",
  Trade = "trade",
  EstateSafe = "estate_safe",
  GarbageContainer = "garbage_container",
  VehicleGloveBox = "vehicle_glove_box",
}
